

import{defineMessages}from'react-intl';

export default defineMessages({
panel_goal_post_text_singular:{
id:'i18n.goal_panel.panel_goal_post_text_singular',
defaultMessage:'Item'},

panel_goal_post_text_plural:{
id:'i18n.goal_panel.panel_goal_post_text_plural',
defaultMessage:'Items'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL1N0b2NrTGlmdC9Hb2FsUGFuZWwvR29hbFBhbmVsLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwicGFuZWxfZ29hbF9wb3N0X3RleHRfc2luZ3VsYXIiLCJpZCIsImRlZmF1bHRNZXNzYWdlIiwicGFuZWxfZ29hbF9wb3N0X3RleHRfcGx1cmFsIl0sIm1hcHBpbmdzIjoiOztBQUVBLE9BQVNBLGNBQVQsS0FBK0IsWUFBL0I7O0FBRUEsY0FBZUEsZ0JBQWU7QUFDNUJDLDhCQUErQjtBQUM3QkMsR0FBSSwrQ0FEeUI7QUFFN0JDLGVBQWdCLE1BRmEsQ0FESDs7QUFLNUJDLDRCQUE2QjtBQUMzQkYsR0FBSSw2Q0FEdUI7QUFFM0JDLGVBQWdCLE9BRlcsQ0FMRCxDQUFmLENBQWYiLCJmaWxlIjoiR29hbFBhbmVsLm1lc3NhZ2VzLmpzIiwic291cmNlUm9vdCI6Ii9hcHAiLCJzb3VyY2VzQ29udGVudCI6WyJcblxuaW1wb3J0IHsgZGVmaW5lTWVzc2FnZXMgfSBmcm9tICdyZWFjdC1pbnRsJztcblxuZXhwb3J0IGRlZmF1bHQgZGVmaW5lTWVzc2FnZXMoe1xuICBwYW5lbF9nb2FsX3Bvc3RfdGV4dF9zaW5ndWxhcjoge1xuICAgIGlkOiAnaTE4bi5nb2FsX3BhbmVsLnBhbmVsX2dvYWxfcG9zdF90ZXh0X3Npbmd1bGFyJyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ0l0ZW0nLFxuICB9LFxuICBwYW5lbF9nb2FsX3Bvc3RfdGV4dF9wbHVyYWw6IHtcbiAgICBpZDogJ2kxOG4uZ29hbF9wYW5lbC5wYW5lbF9nb2FsX3Bvc3RfdGV4dF9wbHVyYWwnLFxuICAgIGRlZmF1bHRNZXNzYWdlOiAnSXRlbXMnLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/components/StockLift/GoalPanel/GoalPanel.messages.js
// module id = 2308
// module chunks = 0